import { render, staticRenderFns } from "./ReportFormModal.vue?vue&type=template&id=60aca508"
import script from "./ReportFormModal.vue?vue&type=script&lang=js"
export * from "./ReportFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports